export default __webpack_public_path__ + "assets/models/703e14ad4672bad8061068ed69d829c8.glb";